import { render, staticRenderFns } from "./ConfigOutputGroups.vue?vue&type=template&id=6f35d254&scoped=true"
import script from "./ConfigOutputGroups.vue?vue&type=script&lang=js"
export * from "./ConfigOutputGroups.vue?vue&type=script&lang=js"
import style0 from "./ConfigOutputGroups.vue?vue&type=style&index=0&id=6f35d254&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f35d254",
  null
  
)

export default component.exports